import React from "react";

// Glossy deep, bright background — slow floating brand mesh blobs + faint grid + grain.
export default function MeshBackground() {
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden bg-white" aria-hidden="true">
      {/* faint engineering grid */}
      <div
        className="absolute inset-0 opacity-[0.55]"
        style={{
          backgroundImage:
            "linear-gradient(to right, rgba(15,23,42,0.035) 1px, transparent 1px), linear-gradient(to bottom, rgba(15,23,42,0.035) 1px, transparent 1px)",
          backgroundSize: "64px 64px",
          maskImage: "radial-gradient(ellipse 80% 60% at 50% 0%, black 30%, transparent 80%)",
          WebkitMaskImage: "radial-gradient(ellipse 80% 60% at 50% 0%, black 30%, transparent 80%)",
        }}
      />
      {/* floating glossy blobs */}
      <div className="absolute -top-40 -left-32 h-[34rem] w-[34rem] rounded-full bg-brand-blue/20 blur-[120px] animate-float-slow" />
      <div className="absolute top-1/3 -right-40 h-[30rem] w-[30rem] rounded-full bg-brand-red/15 blur-[130px] animate-float-slow-2" />
      <div className="absolute bottom-0 left-1/4 h-[26rem] w-[26rem] rounded-full bg-brand-blue-light/15 blur-[120px] animate-float-slow" />
      {/* grain */}
      <div className="grain absolute inset-0 opacity-[0.04]" />
    </div>
  );
}
